// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loupe_eye-dropper_pJjBk {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 100%;
  border: 1px solid #222;
}

[data-paint-theme='dark'] .loupe_eye-dropper_pJjBk {
  border-color: #888;
}
`, "",{"version":3,"sources":["webpack://./../scratch-paint/src/components/loupe/loupe.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".eye-dropper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-radius: 100%;\n  border: 1px solid #222;\n}\n\n[data-paint-theme='dark'] .eye-dropper {\n  border-color: #888;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"eye-dropper": `loupe_eye-dropper_pJjBk`,
	"eyeDropper": `loupe_eye-dropper_pJjBk`
};
export default ___CSS_LOADER_EXPORT___;
